<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'businessIntelligence.retencaoVeiculo.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'businessIntelligence.retencaoVeiculo.categoria'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let categoria of filtrosCategoriaOs.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerCategoriaOs(categoria)">
                  {{categoria.descricao}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerCategoriaOs(categoria)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarCategoriaOs()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.retencaoVeiculo.periodo'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'businessIntelligence.retencaoVeiculo.periodoPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2013:2030"
                  view="month">
                </p-calendar>
              </div>
              <div class="col col-8">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'businessIntelligence.retencaoVeiculo.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <!-- Carga Inicial da tela -->
    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div translate *ngIf="dealersDados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.retencaoVeiculo.nenhumRegistroExibir'}}
    </div>

    <!-- <div translate *ngIf="dealersDados?.length <= 0" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.retencaoVeiculo.nenhumRegistroExibir'}}
    </div> -->
    <p-table #dt [resizableColumns]="true" *ngIf="dealersDados?.length > 0" [value]="dealersDados" dataKey="id"
      selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
      [columns]="selectedColumns" [paginator]="dealersDados?.length > 15" [rows]="15" [loading]="loading"
      [columns]="cols" [value]="rows" [autoLayout]="true"
      currentPageReportTemplate="{{'businessIntelligence.retencaoVeiculo.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]" [globalFilterFields]="['codDealer','nome','data','partNumber',
        'descricaoItem','quantidade','valorVenda','origem','documento','inventFinalQtd']" id="excel-table">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.field == 'detalhe'" [translate]="getTranslate(col.header)" class="text-center"
              style="background-color:black;color:white;">
              {{col.header}}
            </th>
            <th *ngIf="col.field != 'detalhe'" class="text-center" [translate]="getTranslate(col.header)"
              [pSortableColumn]="col.field" style="background-color:black;color:white;">
              {{col.header}}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-registro let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field == 'qtd_visit'" class="text-center">
              <a class="link" (click)="abrirDrilldownPrimeiroRetorno(registro)">
                {{ registro[col.field] }}
              </a>
            </td>
            <td *ngIf="col.field == 'chassiFaltante'" class="text-center">
              <a class="link" (click)="getChassiFaltante(registro)">
                {{ registro[col.field] }}
              </a>
            </td>
            <td *ngIf="col.field != 'chassiFaltante' && col.field != 'qtd_visit'" class="text-center">
              {{ col.type ? col.type.transform(registro[col.field], col.arg1) : registro[col.field] }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.field == 'delivery_year'" class="text-center" style="background-color:black;color:white;">
              Total
            </td>
            <td *ngIf="col.field == 'qtd_visit'" class="text-center" style="background-color:black;color:white;">
              {{totalQtdVisit}}
            </td>
            <td *ngIf="col.field == 'qtd_car_parc'" class="text-center" style="background-color:black;color:white;">
              {{totalQtdCarParc}}
            </td>
            <td *ngIf="col.field == 'chassiFaltante'" class="text-center" style="background-color:black;color:white;">
              <a class="link-total" (click)="getChassiFaltante(registro)">
                {{totalChassis}}
              </a>
            </td>
            <td *ngIf="col.field == 'retencao'" class="text-center" style="background-color:black;color:white;">
              {{totalQtdRetention}}
            </td>
            <!-- <td
              *ngIf="col.field != 'delivery_year' && col.field != 'qtd_visit' && col.field != 'qtd_car_parc' && col.field != 'retencao'"
              class="text-center" style="background-color:black;color:white;">
              {{col.footer}}
            </td> -->
          </ng-container>
        </tr>
      </ng-template>
    </p-table>

    <div *ngIf="dadosAnaliticos?.length > 0" class="mt-3">
      <p-table id="dtAnalitico" [columns]="columnsAnalytical" [value]="dadosAnaliticos"
        styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
        [paginator]="dadosAnaliticos.length > 10" [rows]="rowsAn" [(first)]="firstAn" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'businessIntelligence.relatorioTaxa.mostrandoRegistrosAnalitico' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]">

        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <th class="text-center" [translate]="getTranslate(col.header)"
                style="background-color:black;color:white;">
                {{col.header}}
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-analitico let-columns="columnsAnalytical">
          <tr>
            <ng-container *ngFor="let col of columnsAnalytical">
              <td class="text-center">
                <div [translate]="getTranslate(analitico[col.field])">
                  {{ col.type ? col.type.transform(analitico[col.field], col.arg1, col.arg2) : analitico[col.field] }}
                </div>
              </td>
            </ng-container>
          </tr>
        </ng-template>

      </p-table>
    </div>

  </div>
</div>

<!-- <p-dialog header="{{'businessIntelligence.retencaoVeiculo.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '600px'}" [modal]="true" [draggable]="false">

  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-dialog styleClass="drilldown-dialog" [header]="tituloDrilldown" [(visible)]="drilldownVisible"
  [style]="{width: '98vw', height: '96vh'}" [contentStyle]="{height: 'calc(96vh - 130px)', overflow: 'auto'}"
  [modal]="true" [draggable]="false" [resizable]="false" (onHide)="limparEstadoDrilldown()">
  <div class="d-flex justify-content-center" *ngIf="drilldownLoading">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!drilldownLoading && drilldownNivel === 1">
    <div *ngIf="dadosMensais.length > 0" class="drilldown-chart">
      <canvas baseChart [datasets]="barChartMensalData" [labels]="barChartMensalLabels" [colors]="barChartColors"
        [options]="barChartMensalOptions" [legend]="barChartLegend" [chartType]="barChartType"
        (chartClick)="onChartMensalClick($event)">
      </canvas>
    </div>
    <div translate *ngIf="dadosMensais.length === 0" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.retencaoVeiculo.nenhumRegistroExibir'}}
    </div>
  </div>

  <div *ngIf="!drilldownLoading && drilldownNivel === 2">
    <div *ngIf="dadosFamilias.length > 0" class="drilldown-chart">
      <canvas baseChart [datasets]="barChartFamiliaData" [labels]="barChartFamiliaLabels" [colors]="barChartColors"
        [options]="barChartFamiliaOptions" [legend]="barChartLegend" [chartType]="barChartType"
        (chartClick)="onChartFamiliaClick($event)">
      </canvas>
    </div>
    <div translate *ngIf="dadosFamilias.length === 0" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.retencaoVeiculo.nenhumRegistroExibir'}}
    </div>
  </div>

  <div *ngIf="!drilldownLoading && drilldownNivel === 3">
    <div class="d-flex justify-content-end mb-2" *ngIf="dadosDetalhe.length > 0">
      <button pButton class="p-button-outlined p-button-secondary p-button-sm" type="button"
        (click)="exportExcelDetalhe()">
        <i class="fa fa-download mr-1"></i>{{'businessIntelligence.retencaoVeiculo.exportExcel' | translate}}
      </button>
    </div>
    <p-table *ngIf="dadosDetalhe.length > 0" [value]="dadosDetalhe"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm p-datatable-gridlines"
      [paginator]="dadosDetalhe.length > 10" [rows]="10" [(first)]="firstDetalhe" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{'businessIntelligence.retencaoVeiculo.mostrandoRegistros' | translate}}"
      [rowsPerPageOptions]="[10,20,30,50,100]">
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" style="background-color:black;color:white;">
            {{'businessIntelligence.retencaoVeiculo.dealer' | translate}}
          </th>
          <th class="text-center" style="background-color:black;color:white;">
            {{'businessIntelligence.retencaoVeiculo.numeroOs' | translate}}
          </th>
          <th class="text-center" style="background-color:black;color:white;">
            {{'businessIntelligence.retencaoVeiculo.dataAbertura' | translate}}
          </th>
          <th class="text-center" style="background-color:black;color:white;">
            {{'businessIntelligence.retencaoVeiculo.dataEncerramento' | translate}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-os>
        <tr>
          <td class="text-center">{{os.dealer}}</td>
          <td class="text-center">{{os.numero_ordem_servico}}</td>
          <td class="text-center">{{os.data_abertura}}</td>
          <td class="text-center">{{os.data_encerramento}}</td>
        </tr>
      </ng-template>
    </p-table>
    <div translate *ngIf="dadosDetalhe.length === 0" class="sem-registros text-muted mt-2">
      {{'businessIntelligence.retencaoVeiculo.nenhumRegistroExibir'}}
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button *ngIf="drilldownNivel > 1" type="button" class="btn btn-outline-secondary" (click)="voltarDrilldown()">
      {{'businessIntelligence.retencaoVeiculo.voltar' | translate}}
    </button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'businessIntelligence.retencaoVeiculo.selecioneCategoriaOS' | translate}}"
  [(visible)]="displayFiltrosOS" [style]="{width: '600px'}" [modal]="true" [draggable]="false">
  <!-- <span class="p-input-icon-left">
    <i class="pi pi-search"></i>
    <input #catOs pInputText type="text" placeholder="Buscar..." [(ngModel)]="catOs.value" class="mb-2" />
  </span> -->

  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosCategoriaOs.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarCategoriaOsFiltro(item)">
        {{item.toDescricao()}}
      </span>
    </ng-container>
  </div>
</p-dialog>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>
